var _excluded = ["searchable", "className", "renderSearchItem", "onSearchChange", "emptyRender", "emptyContent", "searchPlaceholder", "style", "searchInputProps"],
    _excluded2 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { AutoSizer, List } from 'react-virtualized';
import { classnames } from '@okee-uikit/react-utils';
import { useToggle } from '@okee-uikit/react-hooks';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { Search } from '../../../common/icons';
import { useCascader, useCascaderSearch } from '../../../hooks/cascader';
import { Empty } from '../../empty';
import { Input } from '../../input';
import { Popover } from '../../popover';
import { HighlightKeyword } from '../../util/HighlightKeyword';
import { CascaderItem } from './CascaderItem';
export function CascaderSearch(props) {
  var locale = useLocale('cascader.empty');
  var searchText = useLocale('cascader.search');

  var _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? false : _props$searchable,
      className = props.className,
      renderSearchItem = props.renderSearchItem,
      onSearchChange = props.onSearchChange,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? searchText : _props$searchPlacehol,
      style = props.style,
      searchInputProps = props.searchInputProps,
      extra = _objectWithoutProperties(props, _excluded);

  var cascader = useCascader();

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      handleShow = _useToggle2[1],
      handleHide = _useToggle2[2];

  var _useCascaderSearch = useCascaderSearch(onSearchChange),
      _useCascaderSearch2 = _slicedToArray(_useCascaderSearch, 3),
      query = _useCascaderSearch2[0],
      queryItemIds = _useCascaderSearch2[1],
      onQueryChange = _useCascaderSearch2[2];

  var onQueryChangeCallback = useCallback(function (event) {
    return onQueryChange(event.target.value);
  }, [onQueryChange]);
  var cls = classnames(usePrefixCls('cascader-search'), className);

  var _ref = searchInputProps || {},
      inputClsName = _ref.className,
      restInputProps = _objectWithoutProperties(_ref, _excluded2);

  var inputCls = classnames(usePrefixCls('cascader-search-input'), inputClsName);
  var popoverCls = usePrefixCls('cascader-search-popover', {
    empty: !queryItemIds.length
  });
  var innerCls = usePrefixCls('cascader-search-popover-inner');
  var handleClick = useCallback(function () {
    if (!cascader.multiple) {
      handleHide();
      onQueryChange('');
    }
  }, []);

  var defaultRenderSearchItem = function defaultRenderSearchItem(item) {
    return React.createElement(HighlightKeyword, {
      label: item.search,
      keyword: cascader.query
    });
  };

  var renderItem = function renderItem(_ref2) {
    var key = _ref2.key,
        index = _ref2.index,
        style = _ref2.style;
    var item = queryItemIds[index];
    return React.createElement("div", {
      style: style,
      key: item
    }, React.createElement(CascaderItem, {
      id: item,
      onClick: handleClick
    }, renderSearchItem || defaultRenderSearchItem));
  };

  var getPopover = function getPopover() {
    if (!queryItemIds.length) {
      return React.createElement("div", {
        className: popoverCls
      }, emptyRender ? emptyRender(locale) : React.createElement(Empty, {
        content: emptyContent ? emptyContent(locale) : locale
      }));
    }

    return React.createElement("div", {
      className: popoverCls,
      style: {
        height: 192,
        width: style === null || style === void 0 ? void 0 : style.width
      }
    }, queryItemIds.length ? React.createElement(AutoSizer, null, function (_ref3) {
      var width = _ref3.width,
          height = _ref3.height;
      return React.createElement(List, {
        width: width,
        height: height,
        rowHeight: cascader.searchItemHeight,
        rowCount: queryItemIds.length,
        rowRenderer: renderItem,
        className: innerCls
      });
    }) : null);
  };

  if (!searchable) {
    return null;
  }

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    style: style,
    className: cls
  }), React.createElement(Popover, {
    lazyInit: true,
    trigger: "focus",
    disableToggleClose: true,
    placement: "bottom-start",
    getPopper: getPopover,
    show: show,
    onShow: handleShow,
    onHide: handleHide,
    offset: {
      x: 0,
      y: 4
    },
    scaleAnimation: "y"
  }, React.createElement(Input, _objectSpread(_objectSpread({
    clearable: true,
    prefix: React.createElement(Search, null)
  }, restInputProps), {}, {
    className: inputCls,
    value: query,
    onChange: onQueryChangeCallback,
    placeholder: searchPlaceholder
  }))));
}